import { render, staticRenderFns } from "./itemField.vue?vue&type=template&id=64f7ff67&scoped=true&"
import script from "./itemField.vue?vue&type=script&lang=js&"
export * from "./itemField.vue?vue&type=script&lang=js&"
import style0 from "./itemField.vue?vue&type=style&index=0&id=64f7ff67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f7ff67",
  null
  
)

export default component.exports